require("dotenv").config();

//export const config = require(`./customer_configurations/${process.env.REACT_APP_CLIENT_CONFIG}/config.json`)